module.exports = __webpack_public_path__ + "media/images/sample900x600-d3154072204bef046aca29a9f713912b.png";